import confetti from 'canvas-confetti'
import {
  getPendingCelebrations,
  hasPendingCelebrations,
  markCelebrationsSeen,
} from './api'

const CELEBRATION_COLORS = ['#43D9A3', '#FFD94F', '#FFFFFF', '#5BC0EB', '#FF7A90']

function wait(milliseconds: number) {
  return new Promise<void>((resolve) => {
    window.setTimeout(resolve, milliseconds)
  })
}

export async function showBrowserConfetti() {
  const baseOptions = {
    colors: CELEBRATION_COLORS,
    disableForReducedMotion: true,
    gravity: 0.9,
    scalar: 0.95,
    ticks: 180,
  }

  void confetti({
    ...baseOptions,
    particleCount: 150,
    spread: 92,
    startVelocity: 42,
    origin: { x: 0.5, y: 0.68 },
  })

  await wait(1800)
}

export async function showPendingCelebration(signal?: AbortSignal) {
  const pending = await getPendingCelebrations(signal)
  if (!hasPendingCelebrations(pending)) return false
  if (signal?.aborted) return false

  await showBrowserConfetti()
  if (signal?.aborted) return false
  await markCelebrationsSeen()
  return true
}
